import script from "./ModalMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalMessage.vue?vue&type=script&setup=true&lang=ts"

import "./ModalMessage.vue?vue&type=style&index=0&id=79bbdf4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79bbdf4c"]])

export default __exports__